// extracted by mini-css-extract-plugin
export default {"threadOption":"styles_threadOption__I15M3","threadOptionIcon":"styles_threadOptionIcon__SYuWo"};